// extracted by mini-css-extract-plugin
export default {"content":"contentLayout_content__kHBBG"};